import axios from "axios";

const marketplaceApiInstance = axios.create({
  baseURL: (process.env.VUE_APP_MARKETPLACE_HOST || ''),
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

marketplaceApiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 502) {
      window.location.href = '/s/market/under_maintenance';
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default marketplaceApiInstance;
export { marketplaceApiInstance as marketplaceApi };
